const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInDowjonesMidnight',
    accessToken: 'accessTokenDowjonesMidnight',
    userRole: 'userRole'
  }
}

export default AppConfig;
